import { ReportUploadPanel } from "@/components/report_upload_panel"

interface WalmartUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload Walmart's "90 days paid detail" export from Supplier One; queues a `sync-walmart` job. */
export function WalmartUploadSection({ integrationId, onUploaded }: WalmartUploadSectionProps) {
  return (
    <ReportUploadPanel
      endpoint="/api/admin/walmart/upload"
      fields={{ integration_id: integrationId }}
      accept={{
        "text/csv": [".csv"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
        "application/vnd.ms-excel": [".xls"],
      }}
      dropLabel="Drag and drop the 90 days paid detail export"
      formatsLabel=".xlsx, .xls, or .csv"
      successMessage={() => ({
        title: "Upload received",
        description: "Your Walmart deductions will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>Upload the export file from Walmart by following these steps:</p>
        <ol class="list-decimal list-inside space-y-1 ml-1">
          <li>
            Log in at{" "}
            <a
              href="https://supplierone.wal-mart.com/"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-blue-700">
              https://supplierone.wal-mart.com/
            </a>
            . You'll need the 2FA code sent to the phone number on the account.
          </li>
          <li>
            Click <strong>Reports</strong> on the left side. If you don't see <strong>Reports</strong>, ask your
            Supplier One account administrator to grant this user access to Reports.
          </li>
          <li>
            Click <strong>Download</strong> on <strong>90 days paid detail</strong>.
          </li>
        </ol>
        <p class="text-xs text-blue-800 italic">
          Upload the exported file as Excel (.xlsx/.xls) or CSV. It should contain columns like Vendor_Number,
          Check_Date, Invoice_Nbr, Adj_Reason_Code, etc.
        </p>
      </div>
    </ReportUploadPanel>
  )
}
